<template>
  <div class="hab-star-rating" :class="className">
    <div class="star-rating">
      <label v-if="label" class="name"
        >{{ label }}<span v-if="required"></span
      ></label>
      <star-rating
        :increment="1"
        :max-rating="5"
        :star-size="starSize"
        :show-rating="false"
        :read-only="disabled"
        :rating="rating"
        :value="value"
        v-on:rating-selected="setRating"
      />
    </div>
    <span v-if="error" class="alert-input-error">{{ error }}</span>
  </div>
</template>

<script>
import StarRating from "vue-star-rating";

export default {
  components: {
    StarRating,
  },
  props: {
    className: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [Number, String],
      default: 0,
    },
    starSize: {
      type: Number,
      default: 20,
    },
  },
  emits: ["onChange"],
  data() {
    return {
      rating: this.value,
    };
  },
  mounted() {
    this.rating = this.value;
  },
  methods: {
    setRating(rating) {
      this.rating = rating;
      return this.$emit("onChange", rating);
    },
  },
};
</script>

<style lang="scss">
.hab-star-rating {
  .vue-star-rating-star {
    line-height: 100%;
  }
}
</style>
<style lang="scss" scoped>
.hab-star-rating {
  position: relative;
  .star-rating {
    .name {
      font-size: 14px;
      font-weight: 500;
      line-height: 120%;
      margin: 0;
      margin-bottom: 10px;
      span {
        margin-left: 4px;
        &::before {
          content: "*";
          color: #f00;
        }
      }
    }
  }
}
</style>
